import { useLanguage } from "@/contexts/LanguageContext";
import { Globe, Scale, Sparkles } from "lucide-react";
import { m } from "framer-motion";

const TrustSection = () => {
  const { t } = useLanguage();

  const trustItems = [
    {
      icon: <Globe className="w-8 h-8" />,
      title: t.trustPublicData,
      description: t.trustPublicDataDesc,
    },
    {
      icon: <Scale className="w-8 h-8" />,
      title: t.trustIndependent,
      description: t.trustIndependentDesc,
    },
    {
      icon: <Sparkles className="w-8 h-8" />,
      title: t.trustProprietary,
      description: t.trustProprietaryDesc,
    },
  ];

  return (
    <section className="py-20 px-6 bg-card border-t border-border overflow-hidden">
      <div className="container mx-auto max-w-5xl">
        <m.h2 
          className="font-serif text-3xl md:text-4xl text-foreground text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
        >
          {t.trustTitle}
        </m.h2>

        <div className="grid md:grid-cols-3 gap-8">
          {trustItems.map((item, index) => (
            <m.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              whileHover={{ 
                y: -8,
                transition: { duration: 0.3 }
              }}
              className="text-center p-6 rounded-2xl bg-background border border-border shadow-soft hover:shadow-medium transition-shadow"
            >
              <m.div 
                className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary/10 flex items-center justify-center text-primary"
                whileHover={{ 
                  scale: 1.1,
                  rotate: 5,
                  transition: { duration: 0.3 }
                }}
              >
                {item.icon}
              </m.div>
              <h3 className="font-serif text-xl text-foreground mb-3">
                {item.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {item.description}
              </p>
            </m.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
